
<a [routerLink] =""  (click)="openDialog('edit_parent')" > Edit</a>
&nbsp;
<a *ngIf="isAdd" [routerLink] =""  (click)="openDialog('add_child')" > Add</a>
